import React from 'react';
import { connect } from 'react-redux';
import { TextField, Button } from '@material-ui/core';
import { getMeetingInfo, setData } from '../redux/dataSlice';
import { getUrlParams, getTenantConfig } from '../config';

import HeaderComponent from './RegForm/HeaderComponent';
import customClientConfig from '../customClientConfig';
import { isContactSpecificCode } from '../contactSpecificCode';

const { company, tenant } = getTenantConfig();

const InviteCodeComponent = (props) => {
  const [inviteCode, setInviteCode] = React.useState('');

  if (props.meetingInfo) {
    // If the user typed a contact-specific code, preserve it in the URL so the
    // reg form can short-circuit the contact lookup. Otherwise use the
    // meeting's canonical invitationcode (historic behavior).
    const trimmed = inviteCode.trim();
    const redirectCode = isContactSpecificCode(trimmed)
      ? trimmed
      : props.meetingInfo.invitationcode;
    props.history.push(`/${redirectCode}${props.history.location.search}`);
  }

  const regSource = getUrlParams('source');
  if (regSource && !props.regSource) {
    props.setData({ regSource });
  }

  const getInputLabel = () => {
    if (customClientConfig[tenant] && customClientConfig[tenant].landingInputLabel) {
      return customClientConfig[tenant].landingInputLabel;
    }
    return 'Invitation Code';
  };

  const handleRegister = () => {
    // Pass the code as-typed; getMeetingInfo itself extracts the meetingId when
    // the code is contact-specific.
    props.getMeetingInfo(inviteCode.trim());
  };

  return (
    <div className="invite-code-component">
      <HeaderComponent company={company} tenant={tenant} suppressBanner />
      <div className="invitation-code-body">
        <p>{getInputLabel()}</p>
        <div className="invite-code-box">
          <TextField
            value={inviteCode}
            onChange={(event) => {
              setInviteCode(event.target.value);
            }}
            margin={'dense'}
            variant={'outlined'}
            inputProps={{
              style: { padding: '1px 12px' }
            }}
          />
          <Button
            variant="contained"
            onClick={handleRegister}
            disabled={props.loadingMeeting}
          >
            {props.loadingMeeting ? 'Loading...' : 'Register'}
          </Button>
        </div>
        {props.invalidMeetingCode && <p>The provided code is invalid.</p>}
        {props.atCapacity && (
          <p>
            Please note that registration for this meeting has reached capacity. <br />
            At this time we are no longer able to accept any additional registrations for this
            program. <br />
            Please reach out to your local sales representative if you have any questions. <br />
            Thank you.
          </p>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ data }) => {
  const { invalidMeetingCode, atCapacity, meetingInfo, loadingMeeting, regSource } = data;
  return { invalidMeetingCode, atCapacity, meetingInfo, loadingMeeting, regSource };
};

export default connect(mapStateToProps, { getMeetingInfo, setData })(InviteCodeComponent);
